<template>
<div>
    <div class="row">
        <template v-for="(item, index) in items">
            <div class="col-6 mt-5" >
                <div class="form-group" style="margin-bottom: 10px;">
                    <label for="">規格</label>
                    <input v-model="item.title" type="text" :name="colName(index, 'title')" class="form-control mb-2">
                </div>
                <div class="form-group" style="margin-bottom: 10px;">
                    <label for="">內容</label>
                    <textarea v-model="item.content" type="text" :name="colName(index, 'content')" class="form-control mb-2"></textarea>
                </div>
            <span v-if="index !=0"><a href="#" class="btn btn-danger" @click="removeItem(item)">刪除</a></span>
        </div>
        </template>
    </div>
    <div class="row mt-5 mb-5">
        <div class="col-12">
            <a href="#" @click.prevent="addItem" class="btn btn-primary">增加</a>
        </div>
    </div>
</div>
</template>


<script>

    export default {
        props: ['lang','datas'],

        data() {
            return {
                items: []
            }
        },
        mounted() {
            this.items = this.datas;
        },
        methods: {
            colName(index, name) {
                return `${this.lang}[specs][${index}][${name}]`;
            },
            addItem(){
                this.items.push({title:null,content:null});
            },
             removeItem(item) {
                var index = this.items.indexOf(item);
                this.items.splice(index, 1);
            },
        }
    }
</script>
